<permission-checker [roles]="roles" (contentInit)="initContent()" (rolesLoaded)="callerRoles = $event">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Contests List|Contests List title@@contests-list-title">Contests</h1>

        <div class="fill-space"></div>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <mat-accordion multi>
        <mat-expansion-panel [expanded]="openExpanded">
          <mat-expansion-panel-header>
            <mat-panel-title
              i18n="Contests List|Contests Available For Enrolment section title@@contests-list-contests-available-for-enrolment-section-title">
              Contests Available For Enrolment
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <mat-spinner *ngIf="!openContestsForShow" color="primary" diameter="50" class="center"></mat-spinner>

          <app-no-content *ngIf="openContestsForShow && !openContestsForShow.length"
                          [compact]="true"
                          title="There are no available contests open for enrol for this competition"
                          i18n-title="Contests List|No open for enrol contests title@@contests-list-no-open-for-enrol-title"
                          details="Please check the contests schedule for the availability"
                          i18n-details="Contests List|No open for enrol contests details@@contests-list-no-open-for-enrol-details">
          </app-no-content>

          <contests-list *ngIf="competitionId && openContestsForShow"
                         [contests]="openContestsForShow"
                         [competitionId]="competitionId"
                         [showEnrolEnd]="true"
                         [editAllowed]="false"
                         [deleteAllowed]="false"
                         [cancelEnrolAllowed]="false"
                         detailsAction="Enrol"
                         i18n-detailsAction="General|Enrol action label@@general-enrol-action-label"
                         (detailsRequested)="enrolForContest($event)"></contests-list>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="historyExpanded">
          <mat-expansion-panel-header>
            <mat-panel-title
              i18n="Contests List|Previously Enrolled Contests section title@@contests-list-previously-enrolled-contests-section-title">
              Previously Enrolled Contests
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <mat-spinner *ngIf="!pastContests" color="primary" diameter="50" class="center"></mat-spinner>

          <app-no-content *ngIf="pastContests && !pastContests.length"
                          [compact]="true"
                          title="You don't have any contests yet"
                          i18n-title="Contests List|No contests title@@contests-list-no-items-title"
                          details="Start with enrolling in a new contest"
                          i18n-details="Contests List|No past contests details@@contests-list-no-past-items-details">
          </app-no-content>

          <contests-list *ngIf="competitionId && pastContests"
                         [contests]="pastContests"
                         [userId]="user?.id"
                         [userRegion]="user?.region"
                         [userSchool]="user?.schoolId"
                         [userRole]="callerRoles && callerRoles.length ? callerRoles[0] : undefined"
                         [competitionId]="competitionId"
                         [editAllowed]="false"
                         [deleteAllowed]="false"
                         [cancelEnrolAllowed]="true"
                         [showPayment]="true"
                         [showTeacher]="showTeacherInfo"
                         [showTeacherDetails]="showContestDetailsForTeacher"
                         [contestsOpenForEnrol]="openContests"
                         (handlePaymentRetry)="enrolForContest($event)"
                         (handlePaymentVerify)="verifyPayment($event)"
                         (listUpdated)="loadOpenContests($event)"></contests-list>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</permission-checker>
